// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__1Xv0d","header":"PatientQuestionnaire_header__1n_km","info":"PatientQuestionnaire_info__SBFcD"};